import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "color-picker"
}
const _hoisted_2 = { class: "font-bold text-lg" }
const _hoisted_3 = { class: "flex items-center flex-wrap gap-2 mb-3" }
const _hoisted_4 = { class: "flex items-center justify-center rounded-lg overflow-hidden border w-full xl:w-fit select-none text-h-neutral-500 cursor-not-allowed" }
const _hoisted_5 = { class: "text-xs p-3" }
const _hoisted_6 = { class: "text-xs p-3 border" }
const _hoisted_7 = { class: "text-xs p-3" }
const _hoisted_8 = { class: "sliders flex flex-col gap-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Slider = _resolveComponent("Slider")!

  return (_ctx.hsl)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.label), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", {
            class: "w-5 h-5 rounded-full",
            style: _normalizeStyle({ backgroundColor: _ctx.hexColor })
          }, null, 4),
          _createVNode(_component_InputText, {
            modelValue: _ctx.hexColor,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.hexColor) = $event)),
            maxlength: 9,
            minlength: 7,
            class: "xl:!w-4/12 !h-10",
            required: ""
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString("H: " + _ctx.hsl.h), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString("S: " + _ctx.hsl.s), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString("L: " + _ctx.hsl.l), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Slider, {
            modelValue: _ctx.hsl.h,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => ((_ctx.hsl.h) = $event)),
              _ctx.updateHSL
            ],
            min: 0,
            max: 360,
            class: "custom-hue"
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          _createVNode(_component_Slider, {
            modelValue: _ctx.hsl.s,
            "onUpdate:modelValue": [
              _cache[2] || (_cache[2] = ($event: any) => ((_ctx.hsl.s) = $event)),
              _ctx.updateHSL
            ],
            min: 0,
            max: 100,
            class: "custom-saturation"
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          _createVNode(_component_Slider, {
            modelValue: _ctx.hsl.l,
            "onUpdate:modelValue": [
              _cache[3] || (_cache[3] = ($event: any) => ((_ctx.hsl.l) = $event)),
              _ctx.updateHSL
            ],
            min: 0,
            max: 100,
            class: "custom-lightness"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ])
      ]))
    : _createCommentVNode("", true)
}